// extracted by mini-css-extract-plugin
export default {"aboutContent":"AboutContent_aboutContent__FNY-u","introContent":"AboutContent_introContent__e5aaY"};